import { render, staticRenderFns } from "./TeamLogo.vue?vue&type=template&id=41f445f1&"
import script from "./TeamLogo.js?vue&type=script&lang=js&"
export * from "./TeamLogo.js?vue&type=script&lang=js&"
import style0 from "./TeamLogo.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports